// =============================================================================
// Lightbox
// =============================================================================

import { Luminous } from 'luminous-lightbox';

$('document').ready(() => {
    const lightboxes = document.querySelectorAll('.lightbox');

    Array.prototype.forEach.call(lightboxes, function (lightbox) {
      new Luminous(lightbox);
    });

    // if (lightboxes) {
    //     new Luminous(lightboxes);
    // }
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/Lightbox.js